import { Helmet } from 'react-helmet-async';
import React from 'react';
import { getOrgTermsContent } from '../../../content/utils.js';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import StepDetailsFormContainer from '../../../containers/portfolio/PortfolioFormContainers/StepDetailsFormContainer.jsx';

const NewPortfolioStepDetails = ({ slug }) => (
  <>
    <Helmet>
      <title>New {getOrgTermsContent('portfolio')} | ChangeSync</title>
    </Helmet>
    <StepDetailsFormContainer slug={slug} />
  </>
);

NewPortfolioStepDetails.getInitialProps = ({ query }) => ({
  slug: query.slug,
});

export default requireAuth(withRouterParams(NewPortfolioStepDetails));
